import { useState, useEffect, useRef } from 'react';
import { Lock, Mail } from 'react-feather';
import { Form, FormGroup, Input, Label, Spinner } from 'reactstrap';
import { Btn, H4, H6 } from 'AbstractElements';
import { EmailAddress, Login, Password, RememberPassword, SignIn } from 'Constant';
import { AuthService } from 'Services/axios/auth.service';
import { toast } from 'react-toastify';
import ReCAPTCHA from 'react-google-recaptcha';

toast.configure();

const LoginForm = () => {
	const recaptchaRef = useRef(null);
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [togglePassword, setTogglePassword] = useState(false);
	const [loading, setLoading] = useState(false);
	const [remember, setRemember] = useState(false);
	const [recaptcha, setRecaptcha] = useState("");

	useEffect(() => {
		const rememberData = localStorage.getItem("REMEMBER");
		if (rememberData) {
			const data = JSON.parse(rememberData);
			setEmail(data.email);
			setRemember(true);
		}
	}, []);

	const handleRememberChange = (event) => {
		setRemember(event.target.checked);
	}

	const resetCaptcha = () => {
		if (recaptchaRef.current) {
			recaptchaRef.current.reset();
			setRecaptcha('');
		}
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		// Always read latest values from the submitted form (covers browser autofill/password manager cases).
		const formData = new FormData(event.currentTarget);
		const latestEmail = (formData.get('email') || '').toString();
		const latestPassword = (formData.get('password') || '').toString();

		// Keep local state aligned with submitted values for UI consistency.
		setEmail(latestEmail);
		setPassword(latestPassword);

		if (!recaptcha) {
			alert('Silakan verifikasi reCAPTCHA terlebih dahulu.');
			return;
		}

		setLoading(true);
		try {
			const response = await AuthService.login({ email: latestEmail, password: latestPassword, recaptcha });
			if (response) {
				localStorage.setItem("TOKEN", response.data.bearer);
				localStorage.setItem("USER", JSON.stringify(response.data.data));
				if (remember) {
					localStorage.setItem("REMEMBER", JSON.stringify({ email: response.data.data.email }));
				} else {
					localStorage.removeItem("REMEMBER");
				}
				toast.success('Login berhasil!', {
					position: toast.POSITION.TOP_RIGHT
				});

				// Memberi jeda 1 detik sebelum redirect
				setTimeout(() => {
					window.location.href = "/";
					setLoading(false);
				}, 1000);
			}
		} catch (error) {
			setPassword('');
			setLoading(false);
			if (error.response && error.response.data) {
				toast.error(error.response.data.message, {
					position: toast.POSITION.TOP_RIGHT
				});
			}
			resetCaptcha();
		}
	}

	const handleChanges = (event) => {
		const { name, value } = event.target;
		if (name === "email") {
			setEmail(value);
		} else if (name === "password") {
			setPassword(value);
		}
	}

	const handleCaptchaChange = (value) => {
		setRecaptcha(value || "");
	}
	return (
		<Form className="theme-form login-form" onSubmit={handleSubmit}>
			<div className="login-header text-center">
				<H4>{Login}</H4>
				<H6>Welcome back! Log in as Admin Brofesional.</H6>
			</div>
			<FormGroup>
				<Label>{EmailAddress}</Label>
				<div className="input-group"><span className="input-group-text"><Mail /></span>
					<Input className="form-control" type="email" required="" name="email" placeholder="Test@gmail.com" defaultValue={email} onChange={handleChanges} />
				</div>
			</FormGroup>
			<FormGroup>
				<Label>{Password}</Label>
				<div className="input-group"><span className="input-group-text"><Lock /></span>
					<Input className="form-control" type={togglePassword ? 'text' : 'password'} name="password" required="" placeholder="*********" onChange={handleChanges} />
					<div className="show-hide" onClick={() => setTogglePassword(!togglePassword)}><span className={togglePassword ? 'hide' : 'show'}></span></div>
				</div>
			</FormGroup>
			<FormGroup className="login-btn form-group">
				<div className="checkbox">
					<Input id="checkbox1" type="checkbox" checked={remember} onChange={handleRememberChange} />
					<Label className="text-muted" for="checkbox1">{RememberPassword}</Label>
				</div>
				{/* <Link to={`${process.env.PUBLIC_URL}/pages/authentication/forget-pwd`} className="link">
                        {ForgotPassword}?
                    </Link> */}
			</FormGroup>
			<FormGroup className="form-group">
				<ReCAPTCHA ref={recaptchaRef} sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ""} onChange={handleCaptchaChange} />
			</FormGroup>
			<FormGroup>
				<Btn attrBtn={{ className: 'btn-block', color: 'primary', type: 'submit', disabled: recaptcha === "" || loading }} >
					{loading ? <Spinner color="light" size="sm" /> : SignIn}
				</Btn>
			</FormGroup>
			{/*<P>Don't have account?
                    <Link to={`${process.env.PUBLIC_URL}/pages/authentication/create-pwd`} className="ms-2">
                        {CreateAccount}
                    </Link>
                    </P>
                */}
		</Form>
	);
};

export default LoginForm;